module.exports = __webpack_public_path__ + "assets/stickeryo_logo-c003b4ff4887065db4e48402262016a9.webp";